<template>
  <site-template>
     <span>

    <header id="header">
    <div class="container">

      <div id="logo" class="pull-left">
         <b-link class="navbar-brand" to="/acesso">
        <h5 class="navbar-brand-full" width="50" height="25" alt="SINDH Desaparecidos">ATENDELIBRAS</h5>
      </b-link>
      </div>
    </div>
  </header>

      <main id="main">
        <section id="schedule" class="section-with-bg">
            <br><br><br>
            <div class="container wow fadeInUp">
              <div class="section-header">
              <h2>ATENDE LIBRAS</h2>
              <p>Podemos já vislumbrar o modo pelo qual a valorização de fatores subjetivos exige a precisão e a definição das novas proposições. Do mesmo modo, a constante divulgação das informações promove a alavancagem do fluxo de informações. No mundo atual, o julgamento imparcial das eventualidades assume importantes posições no estabelecimento das diversas correntes de pensamento. Nunca é demais lembrar o peso e o significado destes problemas, uma vez que o surgimento do comércio virtual afeta positivamente a correta previsão de todos os recursos funcionais envolvidos.</p>
            </div>

                <div class="tab-content row justify-content-center">
                    <div role="tabpanel" class="col-lg-11 tab-pane fade show active" id="day-1">
                          <video controls id="video1" style="width: 100%; height: auto; margin:0 auto; frameborder:0;">
                             <source src="http://localhost:84/videos/video-inicial.mp4" type="video/mp4">
                          </video>
                        <div class="col-lg-3 offset-lg-5 col-md-6 offset-md-6 footer-links">
                           <br>
                          <b-row class="col-lg-3 col-md-6 footer-contact">
                              <b-button variant="primary"><i class="fa fa-mail-reply-all"></i> Continuar</b-button>
                          </b-row>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      </main>

      <footer id="footer">
        <div class="container">
            <div class="copyright"><strong>ATENDE LIBRAS</strong></div>
        </div>
      </footer>

         <button class="back-to-top"><i class="fa fa-angle-up"></i></button>
    </span>
  </site-template>
</template>

<script>
import SiteTemplate from '@/templates/site-externo/SiteTemplate'

export default {
  name: 'HomeExterna',
  components: {
    SiteTemplate
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/site/externa/Home.vue